import EventBus from '../../../shared/js/wirebox/event-bus'
import '../../../shared/js/wirebox/modules/storage'
import jQuery from 'jquery'
import 'jquery-serializejson'
import '../../../shared/js/utilities/loading-animation'

class Archive {
    
    /**
     * Construct component
     * @param params
    */
    constructor({container, countText, descending = true, filterForm, key, template, updatedTime}) {
        
        /**
         * List container
         * @type object
        */
        this.container = container
        
        /**
         * Count text jQuery element
         * @type object
        */
        this.countText = countText
        
        /**
         * Descending order
         * @type bool
        */
        this.descending = descending
        
        /**
         * Filter form jQuery element
         * @type object
        */
        this.filterForm = filterForm
        
        /**
         * Storage key
         * @type string
        */
        this.key = key
        
        /**
         * Page number
         * @type integer
        */
        this.page = -1
        
        /**
         * Template jQuery element
         * @type object
        */
        this.template = template
        
        /**
         * Template HTML
         * @type string
        */
        this.templateHtml = this.template.html()
        
        /**
         * Updated time
         * @type float
        */
        this.updatedTime = updatedTime
        
        /**
         * Filter hack (because reset event misbehaves -_-)
         * @type bool
        */
        this.filterHack = false
        
        //Set "this" bindings on events
        this.handleScroll = this.handleScroll.bind(this)
        
    }
    
    /**
     * Run module
    */
    run() {
        
        //Bookmarks page logic
        if (typeof isBookmarks !== 'undefined' && isBookmarks) {
            this.loadItems()
            return
        }
        
        //Check whether up-to-date items are saved in local storage
        EventBus.publish('storage.read', {
            key: this.key,
            callback: (value) => {
                
                if (value) {
                    
                    //Convert stored string to object
                    const data = JSON.parse(value)
                    
                    //Continue only if stored update time matches value from server
                    if (data.time == this.updatedTime) {
                        this.incrementPage()
                        this.renderItems(data.items)
                        this.stopLoadingAnimation()
                        this.bindScrollEvent()
                        return
                    }
                    
                }
                    
                //Load items
                this.loadItems((response) => {
                    
                    //Save items in storage
                    EventBus.publish('storage.write', {
                        key: this.key,
                        value: JSON.stringify({
                            items: response.items,
                            time: this.updatedTime,
                            total: response.total
                        })
                    })
                    
                })
                    
            }
        })

    }
    
    /**
     * Load items
     * @param callback
    */
    loadItems(callback) {
        
        //Increment page
        this.incrementPage()
        
        //Show loading animation
        EventBus.publish('loading.start', this.container)
        
        //Compile filter params
        const filters = {}
        if (!this.filterHack) {
            jQuery.each(this.filterForm.serializeJSON(), (key, value) => {
                if (value) {
                    filters[key] = value
                }
            })
        }
        else {
            this.filterHack = false
        }
        
        if (isBookmarks) {
            filters.bookmarked = true
        }
        
        //Retrieve items from server
        jQuery.post(this.container.data('url'), {
            order: (this.descending ? 'desc' : 'asc'),
            page: this.page,
            filters: filters
        }, (response) => {
            
            //Render items
            this.renderItems(response.items)
            
            //Handle callback
            if (typeof callback == 'function') {
                callback(response)
            }
            else {
                
                //Update count text
                this.countText.text(response.count)
                
            }
            
            //Cancel if no more results
            if (!response.more) {
                return
            }
            
            //Re-bind scroll event
            this.bindScrollEvent()
            
            //Automatically recurse scroll event in case user is on massive screen
            this.handleScroll()
            
        }).always(() => {
            this.stopLoadingAnimation()
        })
        
    }
    
    /**
     * Stop loading animation
    */
    stopLoadingAnimation() {
        EventBus.publish('loading.stop', this.container)
    }
    
    /**
     * Handle window scroll event
    */
    handleScroll() {
        
        const win = jQuery(window)
        
        //Lazy-load when scrolled past bottom of items list
        if ((win.scrollTop() + win.height()) > (this.container.offset().top + this.container.height())) {
            
            //Unbind scroll event
            this.unbindScrollEvent()
            
            //Load next page of items
            this.loadItems()
            
        }
        
    }
    
    /**
     * Increment page number
    */
    incrementPage() {
        this.page ++
    }
    
    /**
     * Handle filter form submission
     * @param event
    */
    handleFilters(event) {
        
        //Cancel default submission
        event.preventDefault()
        
        //Perform new search
        this.newSearch()
        
    }
    
    /**
     * Perform new search
    */
    newSearch() {
        
        //Reset page number
        this.page = -1
        
        //Empty results
        this.container.empty()
        
        //Unbind scroll event
        this.unbindScrollEvent()
        
        //Load items
        this.loadItems()
        
    }
    
    /**
     * Handle ordering
    */
    handleOrdering() {
        
        this.descending = !this.descending
        
        //Perform new search
        this.newSearch()
        
    }
    
    /**
     * Bind scroll event
    */
    bindScrollEvent() {
        jQuery(window).scroll(this.handleScroll)
    }
    
    /**
     * Unbind scroll event
    */
    unbindScrollEvent() {
        jQuery(window).off('scroll', this.handleScroll)
    }
    
    /**
     * Bind form reset event
    */
    bindFilterEvents() {
        
        //Reset
        this.filterForm.on('reset', () => {
            this.filterHack = true
            this.newSearch()
        })
        
        
    }
    
}

export default Archive